import { render } from "./AgentPropertyView.vue?vue&type=template&id=8fb05d1e&scoped=true"
import script from "./AgentPropertyView.vue?vue&type=script&lang=js"
export * from "./AgentPropertyView.vue?vue&type=script&lang=js"

import "./AgentPropertyView.vue?vue&type=style&index=0&id=8fb05d1e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8fb05d1e"]])

export default __exports__